<div class="At-Sidebar At-SidebarActivity At-CustomScroll" >
    <div class="At-ActivityTop">
        <div class="At-CloseSidebar" (click)="close()"> <i class="icon-cancel"></i></div>
        <div class="At-AddUser"> <i class="icon-user-add"></i></div>
        <div class="At-ActivityTopInner">
            <figure class="AT-ActivityImg">
                <img src="assets/images/profile/activity-pic.png" class="img-fluid" alt="">
            </figure>
            <div class="At-ActivityTitle">
                <h5>Sarah Daniel • donny</h5>
                <p>Last seen 22:09 </p>
            </div>
            <ul class="AT-ActivityBtns">
                <li>
                    <a href="javascript:void(0);" routerLink="/audio-call"> <i class="icon-phone"></i></a>
                </li>
                <li>
                    <a href="javascript:void(0);" routerLink="/dashboard/messages"><i class="icon-chat"></i></a>
                </li>
                <li>
                    <a href="javascript:void(0);" routerLink="/video-call"><i class="icon-video-camera"></i></a>
                </li>
            </ul>
        </div>
    </div>
    <!-- At-ActivityTop ends  -->
    <div class="At-ActivityMiddle">
        <div>
            <tabset>
                <tab heading="Activity" id="tab1">
                    <div class="At-ActivityMiddleInner">
                        <div class="At-PostBox mb-4">
                            <div class="At-InfoBox At-InfoPost">
                                <div class="At-InfoImg">
                                    <figure>
                                        <img src="assets/images/profile/profile-small.png" class="img-fluid " alt="">
                                        <div class="At-badgePurple"><i class="icon-bage"></i></div>
                                    </figure>
                                </div>
                                <div class="At-InfoTitle d-flex">
                                    <div class="At-TitleLeft">
                                        <h5>Julian • <span class="At-TextRedLight">jona</span> • <span
                                                class="At-TextRedLight">COO</span>
                                        </h5>
                                        <h6><i class="icon-location"></i>London, UK • <span>2m ago</span></h6>
                                    </div>
                                    <div class="At-TitleRight">
                                        <i class="icon-more"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="At-PostMainImg">
                                <figure>
                                    <div class="AtImgOverlay"></div>
                                    <img src="assets/images/posts/post-img1.jpg" class="img-fluid w-100" alt="">
                                </figure>
                                <ul class="At-PostShareUl d-flex align-items-center">
                                    <li>
                                        <h6><i class="icon-like"></i> 2211</h6>
                                    </li>
                                    <li>
                                        <h6><i class="icon-comment"></i>150</h6>
                                    </li>
                                    <li>
                                        <h6><i class="icon-send"></i>221</h6>
                                    </li>
                                </ul>
                                <i class="icon-save"></i>
                            </div>
                            <div class="At-PostDescription">
                                <p>Lorem ipsum dolor sit amet, consectetur adiping elit, sed do eiusmod tempor
                                    incididunt ...</p>
                            </div>
                        </div>
                        <!-- At-PostBox ends -->
                        <div class="At-ViewComment">
                            <p class="At-ViewAll">View all 150 comments</p>
                            <ul class="At-CommentUl">
                                <li>
                                    <p>
                                        <span class="At-TextBlue">jason69: </span>Bring me a hoodie from there will ya
                                        <i class="icon-face-emoji At-EmojiYellow"> </i>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <span class="At-TextBlue">softpetal:): </span>enjoy sweetieee <i
                                            class="icon-like At-TextRed"> </i>
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <!-- At-ViewComment ends  -->
                    </div>
                </tab>
                <tab heading="Media">
                    <div class="At-ActivityMiddleInner">
                        <ul class="At-MediaBox">
                            <li>
                                <figure>
                                    <img src="assets/images/posts/media1.jpg" class="img-fluid" alt="">
                                </figure>
                            </li>
                            <li>
                                <figure>
                                    <img src="assets/images/posts/media2.jpg" class="img-fluid" alt="">
                                </figure>
                            </li>
                            <li>
                                <figure>
                                    <img src="assets/images/posts/media3.jpg" class="img-fluid" alt="">
                                </figure>
                            </li>
                            <li>
                                <figure>
                                    <img src="assets/images/posts/media4.jpg" class="img-fluid" alt="">
                                </figure>
                            </li>
                            <li>
                                <figure>
                                    <img src="assets/images/posts/media5.jpg" class="img-fluid" alt="">
                                </figure>
                            </li>
                            <li>
                                <figure>
                                    <img src="assets/images/posts/media6.jpg" class="img-fluid" alt="">
                                </figure>
                            </li>
                            <li>
                                <figure>
                                    <img src="assets/images/posts/media1.jpg" class="img-fluid" alt="">
                                </figure>
                            </li>
                            <li>
                                <figure>
                                    <img src="assets/images/posts/media2.jpg" class="img-fluid" alt="">
                                </figure>
                            </li>
                            <li>
                                <figure>
                                    <img src="assets/images/posts/media3.jpg" class="img-fluid" alt="">
                                </figure>
                            </li>
                            <li>
                                <figure>
                                    <img src="assets/images/posts/media4.jpg" class="img-fluid" alt="">
                                </figure>
                            </li>
                            <li>
                                <figure>
                                    <img src="assets/images/posts/media5.jpg" class="img-fluid" alt="">
                                </figure>
                            </li>
                            <li>
                                <figure>
                                    <img src="assets/images/posts/media6.jpg" class="img-fluid" alt="">
                                </figure>
                            </li>
                        </ul>
                    </div>

                </tab>
                <tab heading="Info">
                    <div class="At-ActivityMiddleInner">
                        <div class="At-ActivityInfoBox">
                            <div class="At-InfoText">
                                <p>Phone Number</p>
                                <h5>+1 554 7854</h5>
                            </div>
                            <div class="At-InfoText">
                                <p>Bio</p>
                                <h5>Lorem ipsum dolor sit amet, consectur adiping elit, sed do eiusmod tempor incididunt
                                </h5>
                            </div>
                            <div class="At-InfoText">
                                <p>Location</p>
                                <h5>NewYork, USA</h5>
                            </div>
                        </div>
                    </div>
                    <!-- At-ActivityMiddleInner ends  -->

                    <div class="At-ActivityMiddleInner At-MiddleBorderTopBottom">
                        <div class="At-SwitchCustom">
                            <span for="customSwitch1" class="At-Mute">Mute Notifications</span>
                            <label class="switch">
                                <input type="checkbox" id="customSwitch1">
                                <span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <!-- At-ActivityMiddleInner ends  -->

                    <div class="At-ActivityMiddleInner">
                        <p class="At-Font16 mb-4">Channels in common</p>

                        <div class="At-InfoBox">
                            <div class="At-InfoImg">
                                <figure class="At-FigureText At-BgLightPurple">
                                    <h4>DT</h4>
                                </figure>
                            </div>
                            <div class="At-InfoTitle d-flex ">
                                <div class="At-TitleLeft">
                                    <h5 class="At-Font2rem">DesignTeam </h5>
                                    <h6> <span class="At-Font17">08 Members</span>   </h6>
                                </div>
                            </div>
                        </div>

                        <div class="At-InfoBox">
                            <div class="At-InfoImg">
                                <figure class="At-FigureText At-BgDarkYellow">
                                    <h4>QA</h4>
                                </figure>
                            </div>
                            <div class="At-InfoTitle d-flex ">
                                <div class="At-TitleLeft">
                                    <h5 class="At-Font2rem">QATeam </h5>
                                    <h6> <span class="At-Font17">08 Members</span></h6>
                                </div>
                            </div>
                        </div>

                        <div class="At-InfoBox">
                            <div class="At-InfoImg">
                                <figure class="At-FigureText At-BgLightPurple">
                                    <h4>DT</h4>
                                </figure>
                            </div>
                            <div class="At-InfoTitle d-flex ">
                                <div class="At-TitleLeft">
                                    <h5 class="At-Font2rem">DesignTeam </h5>
                                    <h6><span class="At-Font17">08 Members</span></h6>
                                </div>

                            </div>
                        </div>
                    </div>
                    <!-- At-ActivityMiddleInner ends  -->
                </tab>
            </tabset>
        </div>
    </div>
    <!-- At-ActivityMiddle ends  -->

</div>
